import { RouteConfig, Route, NavigationGuardNext } from "vue-router";
const tabOneWelcome = () => import("./quote/views/tab-one.vue");
const tabTwoIntegroMax = () => import("./quote/views/tab-two.vue");
const tabthreeIntegroMax = () => import("./quote/views/tab-three.vue");
const tabFourIntegroMax = () => import("./quote/views/tab-four.vue");
const policyOwner = () => import("../shared/policyOwner.vue");
const personToCover = () => import("../shared/personToCover.vue");
const optionals = () => import("../shared/Optionals.vue");
const APSummary = () => import("../shared/ApSummary.vue");
const FinalPayment = () => import("../shared/finalPayment.vue");

const pageTitle = 'Cotizá tu seguro de Accidentes personales en Ocasión de Trabajo o Actividad | Sancor Seguros';
const contentMetaData = 'Cotizá tu seguro de Accidentes personales en Ocasión de Trabajo o Actividad de manera rápida y sencilla.Compará precios y encontrá la cobertura que mejor se adapte a tus necesidades y presupuesto.'

const routes: Array<RouteConfig> = [    
    {
        path: "/Integro-Max/DatosContratante",
        name: "integro-max-tab-two",
        component: tabTwoIntegroMax,
        meta: {
            title: () => 'Datos de la Persona que contrata',
            pageTitle: pageTitle,
            metaTags: [
                {
                    name: 'description',
                    content: contentMetaData
                },
            ]
        }
    },

    {
        path: "/integro-max/DatosVigencia",
        name: "integro-max-tab-three",
        component: tabthreeIntegroMax,
        meta: {
            title: () => 'Datos de que quieres contratar',
            pageTitle: pageTitle,
            metaTags: [
                {
                    name: 'description',
                    content: contentMetaData
                },
            ]
        }
    },

    {
        path: "/integro-max/Planes",
        name: "integro-max-tab-four",
        component: tabFourIntegroMax,
        meta: {
            title: () => 'Elegí el Plan',
            pageTitle: pageTitle,
            metaTags: [
                {
                    name: 'description',
                    content: contentMetaData
                },
            ]
        }
    },

    {
        path: "/integro-max/Contratante",
        name: "integro-max-tab-policyOwner",
        component: policyOwner,
        meta: {
            title: () => 'Datos de la Persona que Contrata',
            pageTitle: pageTitle,
            metaTags: [
                {
                    name: 'description',
                    content: contentMetaData
                },
            ]
        }
    },

    {
        path: "/integro-max/datosAsegurado",
        name: "integro-max-tab-personToCover",
        component: personToCover,
        meta: {
            title: () => 'Datos de la Persona a Cubrir',
            pageTitle: pageTitle,
            metaTags: [
                {
                    name: 'description',
                    content: contentMetaData
                },
            ]
        }
    },

    {
        path: "/integro-max/opcionales",
        name: "integro-max-tab-optionals",
        component: optionals,
        meta: {
            title: () => 'Clausulas opcionales',
            pageTitle: pageTitle,
            metaTags: [
                {
                    name: 'description',
                    content: contentMetaData
                },
            ]
        }
    },

    {
        path: "/integro-max/resumen",
        name: "integro-max-APSummary",
        component: APSummary,
        meta: {
            title: () => 'Resumen',
            pageTitle: pageTitle,
            metaTags: [
                {
                    name: 'description',
                    content: contentMetaData
                },
            ]
        }
    },
    {
        path: "/integro-max/finContrato",
        name: "integro-max-APFinalPayment",
        component: FinalPayment,
        meta: {
            pageTitle: pageTitle,
            metaTags: [
                {
                    name: 'description',
                    content: contentMetaData
                },
            ]
        },
        beforeEnter: (to: Route, from: Route, next: NavigationGuardNext): void => {
            const { ParamId, ExternalIdentifier, ChannelId } = to.query as {
                ParamId?: string;
                ExternalIdentifier?: string;
                ChannelId?: string;
            };

            // Si llega alguno de los tres parámetros, se guarda en sessionStorage
            if (ParamId || ExternalIdentifier || ChannelId) {
                if (ParamId) {
                    sessionStorage.setItem("ParamId", ParamId);
                }
                if (ExternalIdentifier) {
                    sessionStorage.setItem("PricingId", ExternalIdentifier);
                }
                if (ChannelId) {
                    sessionStorage.setItem("ChannelId", ChannelId);
                }

                sessionStorage.setItem("ExitOrContinueModal", "false");

                const timeStart = new Date();
                sessionStorage.setItem("TimeStartPaymentComplete", JSON.stringify(timeStart));

                next({ path: to.path, query: {} });
            } else {
                // Si no hay query params, seguimos normalmente
                next();
            }
        }
    },
    // Ruta comodín debe ir al final siempre
    {
        path: "/Integro-Max/:subpath*",
        name: "integro-max-tab-One",
        component: tabOneWelcome,
        meta: {
            title: () => 'Datos personales',
            pageTitle: pageTitle,
            metaTags: [
                {
                    name: 'description',
                    content: contentMetaData
                }
            ]
        },
        beforeEnter: (to: Route, from: Route, next: NavigationGuardNext): void => {
            const { utm_source } = to.query as { utm_source?: string };

            const existente = sessionStorage.getItem("Referente");
            if (!existente) {
                if (utm_source) {
                    sessionStorage.setItem("Referente", utm_source);
                }
                else {
                    if (document.referrer != '') {
                        sessionStorage.setItem("Referente", document.referrer);
                    }
                    else {
                        sessionStorage.setItem("Referente", null);
                    }
                }
            }

            const { utm_medium } = to.query as { utm_medium?: string };

            const existente_medium = sessionStorage.getItem("Medium");
            if (!existente_medium) {
                if (utm_medium) {
                    sessionStorage.setItem("Medium", utm_medium);
                }
                else {
                    sessionStorage.setItem("Medium", 'organic');
                }
            }

            if (Object.keys(to.query).length > 0) {
                next({ path: to.path, query: {} });
            } else {
                next();
            }
        }
    },
   
];

export default routes;
